<template>
	<div class="myOrder layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;z-index: 0;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="setClass(1)" v-if="showClass!=1" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i> 我的订单
			</div>
		</div>
		<div class="sxBox">
			<div class="layui-form f_row al_itm">
				<select lay-filter="status" id="select">
					<option value="">订单状态</option>
					<option :value="item.id" v-for="(item,i) in clasList" :key="i">{{item.title}}</option>
				</select>
				<div class="layui-inline f_row al_itm margin_l20">
					<div class="layui-input-inline" style="width: 100px;">
						<input type="text" class="layui-input" id="times1" readonly placeholder="开始日期">
					</div>
					<div class="layui-form-mid" style="margin: 0 10px;">-</div>
					<div class="layui-input-inline" style="width: 100px;">
						<input type="text" class="layui-input" id="times2" readonly placeholder="结束日期">
					</div>
				</div>
				<button type="button" class="layui-btn zt_color margin_l20" @click="onSearch">搜索</button>
				<button type="button" class="layui-btn zt_color margin_l20" @click="onReset">重置</button>
				<button type="button" class="layui-btn zt_color margin_l20" @click="onExport">导出订单列表</button>
			</div>
		</div>
		<div>
			<table class="layui-table align_center" id="orders" style="width:90%;margin:0 5%;">
				<colgroup>
					<col width="80">
					<col width="210">
					<col>
					<col>
					<col>
					<col>
					<col>
					<col>
					<col>
					<col width="180">
				</colgroup>
				<thead>
					<tr>
						<th class="align_center">序号</th>
						<th class="align_center">订单编号</th>
						<th class="align_center">订单数量</th>
						<th class="align_center">钢网数量</th>
						<th class="align_center">交付类型</th>
						<th class="align_center">下单时间</th>
						<th class="align_center">发货时间</th>
						<th class="align_center">订单状态</th>
						<th class="align_center">订单金额</th>
						<th class="align_center">尾款金额</th>
						<th class="align_center">订单操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in datas" :key="i">
						<td>{{i+1}}</td>
						<td>{{item.order_num}}</td>
						<td>{{item.task_num}}</td>
						<td>{{item.buy_num}}</td>
						<td :class="item.is_fast_text == '普通件' ? '' : 'jiaji'">{{item.is_fast_text}}</td>
						<td>{{item.time}}</td>
						<td>{{item.time2}}</td>
						<td style="color: rgb(255, 152, 0);" v-if='item.status == 3 && item.sales_status == 1'>工程师返工</td>
						<td style="color: rgb(255, 152, 0);" v-else-if='item.status == 6 && item.sales_status == 2'>工厂返工</td>
						<td style="color: rgb(72, 118, 255);" v-else>{{item.status_text}}</td>
						<td>{{item.price}}</td>
						<td>{{item.add_price ? item.add_price : '0'}}</td>
						<td>
							<button @click="showDetails(item.order_num)" class="layui-btn layui-btn-sm zt_color">详情</button>
							<button @click="copyOrderInfo(item.order_num)" v-if="item.status != 1 && item.status != 15 && item.attr_info_id" class="layui-btn layui-btn-sm layui-btn-normal">再来一单</button>
							<button v-else class="layui-btn layui-btn-sm layui-btn-disabled">再来一单</button>
						</td>
					</tr>
					<tr v-if="datas.length == 0">
						<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="11">暂无数据</td>
					</tr>
				</tbody>
			</table>
			<div id="lypages" style="margin-left: 5%;"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'myOrder',
		data() {
			return {
				show: false,
				dscModel: false,
				showClass: 1,
				forms: '',
				uploads: '',
				nowTimes: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
				value: '',
				value2: '',
				status: '',
				clasList: [{
						title: '待付款',
						id: 1
					},
					{
						title: '待完成',
						id: 2
					},
					{
						title: '已完成',
						id: 3
					},
					{
						title: '售后处理',
						id: 4
					},
				],
				datas: [],
				pages: 1,
				limit: 10,
				count: 1,
				search: 0,
			}
		},
		created() {
			this.getData();
		},
		mounted() {
			let _this = this;
			layui.use(['form', 'laydate'], () => {
				this.forms = layui.form;
				this.forms.render('select');
				this.forms.on('select(status)', function(data) {
					_this.status = data.value;
				});
				var laydate = layui.laydate;
				laydate.render({
					elem: '#times1', //指定元素
					theme: '#4876FF',
					max: this.nowTimes,
					done: function(value, date, endDate) {
						let time = new Date(value);
						let y = time.getFullYear();
						let m = time.getMonth() + 1;
						let d = time.getDate();
						let start = new Date(y + '/' + m + '/' + d);
						_this.value = new Date(start).getTime() / 1000;
					}
				});
				laydate.render({
					elem: '#times2', //指定元素 
					theme: '#4876FF',
					max: this.nowTimes,
					done: function(value, date, endDate) {
						let time = new Date(value);
						let y = time.getFullYear();
						let m = time.getMonth() + 1;
						let d = time.getDate();
						let end = new Date(y + '/' + m + '/' + d);
						_this.value2 = new Date(end).getTime() / 1000 + 86399;
					}
				});
			});
		},
		methods: {
			onExport() {
				let dates = "";
				let t = new Date();
				dates = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate();
				let _this = this;
				let obj = {
					token: this.getCookie('token'),
					status: 3
				}
				let value = _this.value;
				let value2 = _this.value2;
				if(value && value2) {
					let val = value2;
					if(value > value2) {
						value2 = value;
						value = val;
					}
					obj.start_time = value;
					obj.end_time = value2;
				}
				if(!value) {
					layer.msg("请选择开始日期", {
						icon: 2,
						anim: 6
					})
					return false;
				} else if(!value2) {
					layer.msg("请选择结束日期", {
						icon: 2,
						anim: 6
					})
					return false;
				}
				api.exportOrderList(obj).then((res) => {
					console.log(res)
					if(res != false || res != 'false') {
						let blobUrl = window.URL.createObjectURL(res);
						let a = document.createElement('a');
						document.body.appendChild(a)
						a.style.display = 'none';
						a.download = '我的订单.xlsx';
						a.href = blobUrl;
						a.click();
						document.body.removeChild(a);
						window.URL.revokeObjectURL(blobUrl); // 释放内存
					} else {
						layer.msg("暂无数据", {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			getData() {
				let _this = this;
				layui.use(['laypage'], () => {
					var laypage = layui.laypage;
					var obj = {
						token: _this.getCookie('token'),
						page: _this.pages,
						limit: _this.limit
					}
					if(this.search == 1) {
						let value = _this.value;
						let value2 = _this.value2;
						if(value && value2) {
							let val = value2;
							if(value > value2) {
								value2 = value;
								value = val;
							}
							obj.start_time = value;
							obj.end_time = value2;
						}
						obj.status = _this.status;
					}
					api.OrderList(obj).then((res) => {
						if(res.code == 1) {
							for(let i = 0; i < res.data.list.length; i++) {
								res.data.list[i].time = _this.getTimes(res.data.list[i].createtime);
								res.data.list[i].time2 = '';
								if(res.data.list[i].f_rework_finish_time) {
									res.data.list[i].time2 = _this.getTimes(res.data.list[i].f_rework_finish_time);
								} else if(res.data.list[i].f_finish_order_time) {
									res.data.list[i].time2 = _this.getTimes(res.data.list[i].f_finish_order_time);
								}
							}
							_this.datas = res.data.list;
							_this.count = res.data.count;
						} else {
							_this.datas = [];
						}
						_this.show = true
						laypage.render({
							elem: 'lypages', //注意，这里的 test1 是 ID，不用加 # 号
							theme: '#4876FF',
							curr: _this.pages,
							count: _this.count,
							limit: 10,
							jump: function(obj, first) {
								if(!first) {
									_this.pages = obj.curr;
									_this.getData();
								}
							}
						});
					})
				})
			},
			onSearch() {
				this.search = 1;
				this.pages = 1;
				this.count = 1;
				this.getData();
			},
			onReset() {
				this.search = 0;
				this.pages = 1;
				$('#select').val('');
				$('#times1').val('');
				$('#times2').val('');
				this.getData();
				this.forms.render();
			},
			showDetails(num) {
				this.$router.push({
					path: '/orderDetail',
					query: {
						id: num
					}
				})
			},
			copyOrderInfo(num) {
				let _this = this;
				api.copyOrderInfo({
					order_num: num,
					token: this.getCookie('token'),
				}).then((res) => {
					if(res.code == 1) {
						let id = res.data.join(",")
						_this.$router.push({
							path: '/shopCar',
						})
					}
				})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.jiaji {
		color: rgba(229, 28, 35, 1);
	}
	
	.layer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 10000;
	}
	
	.myOrder {
		font-family: SourceHanSansSC;
	}
	
	.sxBox {
		padding: 20px 5% 10px;
	}
	
	#evaluate {
		padding: 0 20px 30px;
	}
	
	#evaluate .title {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		line-height: 50px;
	}
	
	#evaluate .layui-form {
		display: flex;
		flex-wrap: wrap;
	}
	
	#evaluate .layui-form-item {
		width: 330px;
		margin-bottom: 0;
	}
	
	#evaluate .layui-form-item h3 {
		line-height: 50px;
	}
	
	#evaluate .layui-form-item .star_total {
		display: flex;
		align-items: center;
	}
	
	#evaluate .layui-form-item .star_box .star_list {
		display: flex;
		align-items: center;
	}
	
	#evaluate .layui-form-item .label {
		width: 100px;
		text-align: right;
	}
	
	#evaluate .layui-form-item .tit {
		line-height: 50px;
	}
	
	#evaluate textarea {
		width: 100% !important;
		border: 1px solid #C9C9C9;
		border-radius: 5px;
		font-size: 14px;
		height: 150px !important;
		resize: none;
		box-sizing: border-box;
		padding: 5px;
	}
	
	.layui-form-item .preview2 {
		width: 110px;
		height: 110px;
		margin-right: 15px;
		margin-bottom: 30px;
	}
	
	.upload_img2 {
		width: 110px;
		height: 110px;
		margin-bottom: 30px;
	}
	
	#star1,
	#star2,
	#star3,
	#star4,
	#star5,
	#star6,
	#star7,
	#star8,
	#star9,
	#star10 {
		position: relative;
		top: 7px;
		margin-left: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/myOrder.vue